export default __webpack_public_path__ + "static/windyhillsbungalow-c1f79c2402827aaa4738674732dac0eb.png";